module.exports = __webpack_public_path__ + "img/water-ladder.c699e819.svg";